import React, { useState } from 'react';
import { Card, Button, Collapse, Alert, Container, Row, Col } from 'react-bootstrap';
import Navbar from "./navbar";
import Contact from "./Contact";
import Footer from "./Footer";
import { useRequirements } from '../hooks/useRequirements';

const Requirements = () => {
  const [openFunctional, setOpenFunctional] = useState(false);
  const [openNonFunctional, setOpenNonFunctional] = useState(false);
  const { requirements, loading, error } = useRequirements();

  if (loading) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Navbar />
        <main className="main-content">
          <Container>
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p className="loading-text">Loading requirements...</p>
            </div>
          </Container>
        </main>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Navbar />
        <main className="main-content">
          <Container className="py-4">
            <Alert variant="danger">
              <Alert.Heading>Error Loading Requirements</Alert.Heading>
              <p>{error}</p>
              <hr />
              <p className="mb-0">
                Please make sure you have added requirements to Firestore. Check the documentation for setup instructions.
              </p>
            </Alert>
          </Container>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <main className="main-content">
        <Container className="py-4">
          {/* Page Header */}
          <div className="section-header">
            <h1>Project Requirements</h1>
            <p>Functional and Non-Functional Requirements for LawBot System</p>
          </div>

          {/* Requirements Cards */}
          <Row className="g-4">
            {/* Functional Requirements Card */}
            <Col lg={6}>
              <Card style={{ minHeight: '400px' }}>
                <Card.Header>
                  <h4 style={{ margin: 0, fontSize: '1.25rem' }}>
                    Functional Requirements
                  </h4>
                  <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.9rem', color: '#8b7355' }}>
                    {requirements.functional.length} Requirements
                  </p>
                </Card.Header>
      <Card.Body>
        <Button
        variant="secondary"
                    onClick={() => setOpenFunctional(!openFunctional)}
                    aria-controls="functional-collapse"
                    aria-expanded={openFunctional}
                    className="mb-3"
                    style={{ width: '100%' }}
      >
                    {openFunctional ? 'Hide Requirements' : 'Show Requirements'}
      </Button>
                  
                  <Collapse in={openFunctional}>
                    <div id="functional-collapse">
                      {requirements.functional.length > 0 ? (
                        <ol style={{ 
                          paddingLeft: '1.5rem', 
                          margin: 0,
                          color: '#d4d4d4'
                        }}>
                          {requirements.functional.map((req, index) => (
                            <li 
                              key={req.id} 
                              style={{ 
                                marginBottom: '0.875rem',
                                lineHeight: '1.6',
                                fontSize: '0.95rem'
                              }}
                            >
                              {req.description || req.text}
                            </li>
                          ))}
                        </ol>
                      ) : (
                        <Alert variant="info">No functional requirements found</Alert>
                      )}
        </div>
    </Collapse>
      </Card.Body>
    </Card>
            </Col>

            {/* Non-Functional Requirements Card */}
            <Col lg={6}>
              <Card style={{ minHeight: '400px' }}>
                <Card.Header>
                  <h4 style={{ margin: 0, fontSize: '1.25rem' }}>
                    Non-Functional Requirements
                  </h4>
                  <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.9rem', color: '#8b7355' }}>
                    {requirements.nonFunctional.length} Requirements
                  </p>
                </Card.Header>
      <Card.Body>
        <Button
        variant="secondary"
                    onClick={() => setOpenNonFunctional(!openNonFunctional)}
                    aria-controls="non-functional-collapse"
                    aria-expanded={openNonFunctional}
                    className="mb-3"
                    style={{ width: '100%' }}
      >
                    {openNonFunctional ? 'Hide Requirements' : 'Show Requirements'}
      </Button>
                  
                  <Collapse in={openNonFunctional}>
                    <div id="non-functional-collapse">
                      {requirements.nonFunctional.length > 0 ? (
                        <ol style={{ 
                          paddingLeft: '1.5rem', 
                          margin: 0,
                          color: '#d4d4d4'
                        }}>
                          {requirements.nonFunctional.map((req, index) => (
                            <li 
                              key={req.id} 
                              style={{ 
                                marginBottom: '0.875rem',
                                lineHeight: '1.6',
                                fontSize: '0.95rem'
                              }}
                            >
                              {req.description || req.text}
                            </li>
                          ))}
                        </ol>
                      ) : (
                        <Alert variant="info">No non-functional requirements found</Alert>
                      )}
      </div>
                  </Collapse>
      </Card.Body>
    </Card>
            </Col>
          </Row>
        </Container>

        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Requirements;
